import graphql from "babel-plugin-relay/macro";

const blocExistsQuery = graphql`
  query BlocExistsQuery($tenantPks: [Int]!) {
    blocExists(tenantPks: $tenantPks) {
      bloc {
        name
      }
      error {
        statusCode
      }
    }
  }
`;

export default blocExistsQuery;
